import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FormSection, InfoProgramSection } from "./Section";
import {
  formInitialValues,
  formSubmmitMapper,
  formValidationSchema,
} from "./Utils";
import { Formik } from "formik";
import { KegiatanApi } from "api";
import { useParams, useHistory } from "react-router-dom/cjs/react-router-dom";
import { ActionButton, BackButton, DataStatus } from "components";

export const TambahKegiatan = () => {
  const { id } = useParams();
  const history = useHistory();
  const [dataProgram, setDataProgram] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
    show: false,
  });
  const getDataSingle = () => {
    setIsLoading(true);
    KegiatanApi.getSingleProgram({ arg: "k", id: id })
      .then(({ data }) => {
        setDataProgram(data?.data);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formSubmitHandler = (value, { setSubmitting }) => {
    KegiatanApi.create(formSubmmitMapper(value))
      .then(() => {
        history.push("/transaksi/kegiatan", {
          alert: {
            show: true,
            variant: "primary",
            text: "Data berhasil disimpan!",
          },
        });
        setAlertConfig({
          show: true,
          text: "Data berhasil disimpan !!",
          variant: "primary",
        });
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          text: "Data gagal disimpan !!",
          variant: "danger",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    getDataSingle();

    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={formInitialValues(dataProgram)}
        validationSchema={formValidationSchema}
        onSubmit={formSubmitHandler}
      >
        {({ isSubmitting, handleSubmit, resetForm }) => (
          <>
            {isLoading ? (
              <DataStatus text="Memuat Data..." loading />
            ) : (
              <>
                <div className="d-flex justify-content-between mb-2">
                  <span style={{ fontSize: "14px" }}>
                    <b>Detail Data Program</b>
                  </span>
                  <BackButton size="sm" onClick={() => history.goBack()} />
                </div>
                <Card className="mb-3">
                  <Card.Body>
                    <InfoProgramSection />
                  </Card.Body>
                </Card>
                <span style={{ fontSize: "14px" }}>
                  <b>Tambah Data Kegiatan</b>
                </span>
                <Card>
                  <Card.Body>
                    <form onSubmit={handleSubmit}>
                      <FormSection />
                      <div className="d-flex justify-content-end mt-2">
                        <ActionButton
                          size="sm"
                          text="Simpan"
                          type="submit"
                          loading={isSubmitting}
                        />
                      </div>
                    </form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        )}
      </Formik>
    </>
  );
};
